export default "__VITE_ASSET__d4c6c1d6__"